<template>
  <GwMenu
    trigger="click"
    :isMovable="true"
    :isInside="isInside"
    class="savedfiltersmenu"
  >
    <template #opener>
      <!-- <div
        class="icon_btn clr-grey mdi mdi-content-save pa-1 text-normal"
      ></div> -->
      <slot name="opener">
        <div
          class="gw_btn-v1 gw_btn csst"
          style="--height: var(--btn-height); padding: 0.25rem"
          @mouseenter="e => fl_positionTooltip(e, { placement: 'right' })"
        >
          <div class="mdi mdi-folder pa-1 text-normal"></div>
          <div
            class="csst_content"
            style="position: fixed"
            v-html="$t('data_table.saved_ranges.title')"
          ></div>
        </div>
      </slot>
    </template>
    <template #default="{ methods }">
      <div
        class="gw_menu f-column cursor-grab"
        style="min-height: 0; max-height: var(--vh-6); --width: clamp(12rem, 42rem, 100vw)"
      >
        <!-- <div class="f-center">
          <div class="text_medium weight_600 mr-auto">
            {{ $t('data_table.saved_ranges.title') }}
          </div>
        </div> -->
        <!-- @close="methods.toggleOpen(false)" -->
        <SavedRangesTableV1
          :namespace="namespace"
          @apply:item="
            item => {
              $emit('apply:item', item)
            }
          "
          @loaded="methods.toggleOpen(true)"
        />
        <!-- style="margin: 0.5rem 0 0 0" -->
        <!-- methods.toggleOpen(false) -->
        <div
          class="mdi mdi-close icon_btn pa-1"
          style="position: absolute; top: 0.5rem; right: 0.5rem"
          @click="methods.toggleOpen(false)"
        ></div>
      </div>
    </template>
  </GwMenu>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import SavedRangesTableV1 from '@/components/DataTables/v2/tables/SavedRangesTableV1/SavedRangesTableV1'

import float_mix from '@/mixins/float_mix'

export default {
  name: 'GwSavedRangesMenu',
  components: {
    SavedRangesTableV1,
    GwMenu,
  },
  mixins: [float_mix],
  props: {
    namespace: { String, required: true },
    isInside: Boolean,
  },
  emits: ['apply:item'],
}
</script>

<style lang="scss" scoped>
.savedfiltersmenu {
  --btn-height: 1.75rem;
}
</style>
